import { useTranslation } from 'react-i18next';
import { Button } from "src/@/components/ui/button"
import {
    Dialog,
    DialogContent,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from "src/@/components/ui/dialog"
import { Input } from "src/@/components/ui/input"
import { RowInput } from "src/components/forms/RowInput"
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from "src/@/components/ui/select"

export default function ModalApis({
    open,
    onClose,
    onSubmit,
    action,
    nome,
    changeNome,
    tipo,
    changeTipo,
}) {
    const { t } = useTranslation('settings');

    return (
        <Dialog open={open} onOpenChange={(val) => !val && onClose()}>
            <DialogContent className="sm:max-w-[425px]">
                <DialogHeader>
                    <DialogTitle>
                        {action === "Criar" ? t('apiKeys.modal.createTitle', 'Nova Chave de API') : t('apiKeys.modal.editTitle', 'Editar Chave de API')}
                    </DialogTitle>
                </DialogHeader>
                <div className="grid gap-4 py-4">
                    <RowInput
                        label={t('apiKeys.modal.nameLabel', 'Nome da Chave')}
                        input={<Input
                            onChange={changeNome}
                            value={nome}
                            placeholder={t('apiKeys.modal.namePlaceholder', 'Ex: Integração XYZ')}
                        />}
                    />

                    <RowInput
                        label={t('apiKeys.modal.typeLabel', 'Tipo de Chave')}
                        input={
                            <Select value={tipo} onValueChange={changeTipo}>
                                <SelectTrigger className="w-full">
                                    <SelectValue placeholder={t('apiKeys.modal.typePlaceholder', 'Selecione o tipo')} />
                                </SelectTrigger>
                                <SelectContent>
                                    <SelectItem value="global">{t('apiKeys.modal.typeOptionGlobal', 'Global')}</SelectItem>
                                    <SelectItem value="whatsapp">{t('apiKeys.modal.typeOptionWhatsapp', 'WhatsApp')}</SelectItem>
                                </SelectContent>
                            </Select>
                        }
                    />
                </div>
                <DialogFooter>
                    <Button onClick={onSubmit}>{action === "Criar" ? t('apiKeys.modal.generateButton', 'Gerar Chave') : t('buttons.save', { ns: 'common' })}</Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    )
}
